<template>
  <div class="main-layout">
    <top-bar class="top-bar"></top-bar>
    <menu-under-bar :data="menu"></menu-under-bar>
    <transition name="list" mode="out-in">
      <router-view class="container"></router-view>
    </transition>
    <footer-menu></footer-menu>
  </div>
</template>

<script>
import TopBar from '@/components/common/TopBar'
import FooterMenu from '@/components/common/FooterMenu'
import MenuUnderBar from '@/components/common/MenuUnderBar'

export default {
  name: 'main-layout',
  components: {
    MenuUnderBar,
    FooterMenu,
    TopBar
  },
  data() {
    return {
      menu: {
        // 0: {
        //     title: 'DASHBOARD',
        //     name: 'dashboard',
        //     sort: 0
        // },
        1: {
          title: 'BOOKING',
          name: 'booking',
          sort: 0
        },
        2: {
          title: 'MESSAGE',
          name: 'message',
          sort: 0
        },
        3: {
          title: 'ALBUM',
          name: 'album',
          sort: 0
        },
        4: {
          title: 'SAVED',
          name: 'saved',
          sort: 0
        },
        5: {
          title: 'ACCOUNT',
          name: 'account',
          sort: 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  top: 20px;
  position: relative;
  margin: auto;
  width: 1118px;

  /*border: 1px dotted gray;*/
  .top-bar {
    position: relative;
    margin: auto;
    width: 1080px;
  }

  .menu-under-bar {
    position: relative;
    margin: 32px auto auto auto;
    width: 1093px;
  }

  .container {
    /*border: 1px solid red;*/
    position: relative;
    margin: 20px auto;
    width: 1080px;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.1s ease-in-out;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
    opacity: 0;
    transform: translateX(30px);
  }
}
</style>
